/**
 * Translations for the auth feature area (LoginPage + NicknameSetupModal).
 * Keep zh and en in lock-step.
 */
const auth = {
  zh: {
    // Brand header
    'auth.brand.title': '小陪伴',
    'auth.brand.tagline': '一起陪你长大 🌟',

    // Tabs
    'auth.tab.child': '孩子登录',
    'auth.tab.parent': '家长入口',

    // Device hints
    'auth.device.ipad.ok': '✅ 已在 iPad 上 — 离屏幕远一点，记得每 20 分钟看看远处休息眼睛 👁️',
    'auth.device.ipad.warn': '👁️ 为了保护眼睛，强烈建议用 iPad 登录玩耍。手机屏幕太小、对孩子视力不友好哦～',
    'auth.parent.deviceHint': '📱 家长后台已经适配手机和电脑，',
    'auth.parent.deviceHintBold': '建议用手机管理',
    'auth.parent.deviceHintTail': ' — 随时随地看动态、批准任务、调金币。',

    // Child login form
    'auth.child.mode.login': '登录',
    'auth.child.mode.register': '自己注册',
    'auth.child.name.label': '你的名字',
    'auth.child.name.placeholder': '爸爸妈妈给你起的名字',
    'auth.child.password.label': '密码',
    'auth.child.submit': '进入 →',
    'auth.child.help.line1': '还没有账号？请爸爸妈妈先用「家长入口」注册，',
    'auth.child.help.line2': '然后在家长后台帮你创建账号 ✨',
    'auth.child.register.intro': '可以先自己注册并开始玩。注册成功会得到 200 金币启动奖励。',
    'auth.child.register.parentToggle.closed': '以后再邀请爸爸妈妈',
    'auth.child.register.parentToggle.open': '现在邀请爸爸妈妈一起加入',
    'auth.child.register.parentEmail.label': '爸爸妈妈邮箱',
    'auth.child.register.rewardHint': '没有填写爸爸妈妈邮箱也可以先玩；以后邀请爸爸妈妈或同学成功加入后，还可以获得 500 金币奖励。',
    'auth.child.register.sendCode': '发送给爸爸妈妈确认 →',
    'auth.child.register.startStandalone': '注册并开始玩 →',
    'auth.child.register.codeSentTo': '确认码已发到',
    'auth.child.register.codeTail': '，请爸爸妈妈把 6 位确认码告诉你。',
    'auth.child.register.activate': '确认并进入 🎉',
    'auth.child.parentNudge.title': '邀请爸爸妈妈一起加入',
    'auth.child.parentNudge.body': '你已经可以先开始玩啦。邀请爸爸妈妈后，可以提醒他们每天领金币、收信、帮你管理任务和学习计划。只有邀请爸妈时才需要填写邮箱。',
    'auth.child.parentNudge.later': '以后再说',
    'auth.child.parentNudge.cta': '去邀请爸妈',

    // Parent mode toggle
    'auth.parent.mode.login': '登录',
    'auth.parent.mode.register': '新家长注册',

    // Parent login mode toggle
    'auth.parent.login.password': '密码登录',
    'auth.parent.login.magic': '邮箱验证码',
    'auth.parent.login.forgot': '忘记密码？通过邮箱重置',

    // Parent login - email step
    'auth.parent.email.label': '邮箱',
    'auth.parent.email.placeholder': 'your@email.com',
    'auth.parent.password.label': '密码',
    'auth.parent.login.sendCode': '发送验证码',
    'auth.parent.login.submit': '登录 →',

    // Parent login - code step
    'auth.parent.code.sentTo': '验证码已发到',
    'auth.parent.code.validity': '。15 分钟内有效。',
    'auth.parent.code.devHeader': '开发模式：',
    'auth.parent.code.devLabel': '验证码',
    'auth.parent.code.label': '6 位验证码',
    'auth.parent.code.placeholder': '000000',
    'auth.parent.code.verifyAndLogin': '验证并登录',

    // Parent register
    'auth.parent.register.intro': '用邮箱和密码注册，点击邮件里的激活链接后进入家长后台，再为孩子创建账号。',
    'auth.parent.register.email.label': '家长邮箱',
    'auth.parent.register.password.label': '设置密码（至少 6 位）',
    'auth.parent.register.invite.label': '邀请码（选填）',
    'auth.parent.register.invite.placeholder': '比如 abc123',
    'auth.parent.register.invite.hint': '✨ 朋友给你的邀请码 — 注册欢迎 +1000，家庭启动后邀请人也得奖励',
    'auth.parent.register.sendCode': '发送激活邮件 →',
    'auth.parent.register.codeSentTo': '验证码已发到',
    'auth.parent.register.codeTail': '，也可以直接点击邮件里的激活链接。',
    'auth.parent.register.activate': '激活并进入 🎉',

    'auth.parent.reset.intro': '输入家长邮箱，我们会发送密码重置链接。',
    'auth.parent.reset.send': '发送重置链接',
    'auth.parent.reset.sentTo': '重置链接和验证码已发送到',
    'auth.parent.reset.newPassword': '新密码（至少 6 位）',
    'auth.parent.reset.submit': '保存新密码',

    // Errors
    'auth.error.childMissing': '请填名字和至少 4 位密码',
    'auth.error.emailMissing': '请填邮箱',
    'auth.error.passwordMissing': '请填密码',
    'auth.error.codeFormat': '请输入 6 位验证码',
    'auth.error.emailFormat': '邮箱格式不对',
    'auth.error.passwordShort': '密码至少 6 位',
    'auth.error.generic': '出错了 😢',

    // Nickname modal
    'nicknameModal.welcome': '欢迎，{name}！',
    'nicknameModal.prompt.line1': '想给自己起一个小别名吗？',
    'nicknameModal.prompt.line2': '这个名字会出现在仓鼠对你说的话里 🐹',
    'nicknameModal.placeholder': '例如：小米、Sunny、超级闪电',
    'nicknameModal.keepLoginName.title': '就用登录名',
    'nicknameModal.keepLoginName.button': '就叫 {name}',
    'nicknameModal.confirm': '就这个！',
    'nicknameModal.error.length': '别名需要 1-20 个字符',
    'nicknameModal.error.saveFailed': '保存失败',

    // ─── Wizard (PR-9 redesign) ─────────────────────────────
    // Step 1 — who are you?
    'auth.wizard.step.label': '第 {n} / {total} 步',
    'auth.wizard.back': '‹ 上一步',
    'auth.wizard.role.title': '你是谁？',
    'auth.wizard.role.subtitle': '点一下下面的大按钮就好啦',
    'auth.wizard.role.child.title': '我是小朋友',
    'auth.wizard.role.child.sub': '玩游戏、聊天、领金币',
    'auth.wizard.role.parent.title': '我是爸爸妈妈',
    'auth.wizard.role.parent.sub': '管理任务、零花钱和学习',

    // Step 2 — have an account?
    'auth.wizard.has.title.child': '你已经有账号了吗？',
    'auth.wizard.has.title.parent': '你已经有账号了吗？',
    'auth.wizard.has.subtitle.child': '没有也没关系，可以现在新建一个 ✨',
    'auth.wizard.has.subtitle.parent': '第一次来？先新建账号；老朋友直接登录就好。',
    'auth.wizard.has.login.title': '我有账号',
    'auth.wizard.has.login.sub': '直接登录',
    'auth.wizard.has.register.title': '新建账号',
    'auth.wizard.has.register.sub.child': '注册并开始玩',
    'auth.wizard.has.register.sub.parent': '用邮箱注册',

    // Step 3 — titles per role × mode
    'auth.wizard.step3.title.childLogin': '小朋友登录',
    'auth.wizard.step3.title.childRegister': '小朋友注册',
    'auth.wizard.step3.title.parentLogin': '家长登录',
    'auth.wizard.step3.title.parentRegister': '家长注册',
    'auth.wizard.step3.title.parentForgot': '重置密码',
  },
  en: {
    // Brand header
    'auth.brand.title': 'Little Buddy',
    'auth.brand.tagline': "Let's grow up together 🌟",

    // Tabs
    'auth.tab.child': 'Kid login',
    'auth.tab.parent': 'Parent area',

    // Device hints
    'auth.device.ipad.ok': "✅ You're on an iPad — sit back a bit, and look far away every 20 minutes to rest your eyes 👁️",
    'auth.device.ipad.warn': '👁️ To protect your eyes, please log in on an iPad. Phone screens are too small and not great for kids.',
    'auth.parent.deviceHint': '📱 The parent dashboard works great on phones and computers — ',
    'auth.parent.deviceHintBold': 'phones recommended',
    'auth.parent.deviceHintTail': ' — check in, approve tasks, and adjust coins anywhere.',

    // Child login form
    'auth.child.mode.login': 'Log in',
    'auth.child.mode.register': 'Sign up',
    'auth.child.name.label': 'Your name',
    'auth.child.name.placeholder': 'The name your parents gave you',
    'auth.child.password.label': 'Password',
    'auth.child.submit': 'Go in →',
    'auth.child.help.line1': "No account yet? Ask your parent to register from \"Parent area\" first,",
    'auth.child.help.line2': 'then they can make an account for you in the parent dashboard ✨',
    'auth.child.register.intro': 'You can start your own account and play right away. New kids get 200 starter coins.',
    'auth.child.register.parentToggle.closed': 'Invite parents later',
    'auth.child.register.parentToggle.open': 'Invite parents now',
    'auth.child.register.parentEmail.label': "Parent's email",
    'auth.child.register.rewardHint': 'You can play without a parent email first; later, successful parent or friend invites can earn a 500-coin reward.',
    'auth.child.register.sendCode': 'Send parent confirmation →',
    'auth.child.register.startStandalone': 'Sign up and play →',
    'auth.child.register.codeSentTo': 'Confirmation code sent to',
    'auth.child.register.codeTail': '. Ask your parent for the 6-digit code.',
    'auth.child.register.activate': 'Confirm & enter 🎉',
    'auth.child.parentNudge.title': 'Invite your parents',
    'auth.child.parentNudge.body': 'You can already start playing. After inviting parents, you can remind them to claim coins, read mail, and help manage tasks and learning plans. A parent email is only needed when you invite them.',
    'auth.child.parentNudge.later': 'Later',
    'auth.child.parentNudge.cta': 'Invite parents',

    // Parent mode toggle
    'auth.parent.mode.login': 'Log in',
    'auth.parent.mode.register': 'New parent sign up',

    // Parent login mode toggle
    'auth.parent.login.password': 'Password',
    'auth.parent.login.magic': 'Email code',
    'auth.parent.login.forgot': 'Forgot password? Reset by email',

    // Parent login - email step
    'auth.parent.email.label': 'Email',
    'auth.parent.email.placeholder': 'your@email.com',
    'auth.parent.password.label': 'Password',
    'auth.parent.login.sendCode': 'Send code',
    'auth.parent.login.submit': 'Log in →',

    // Parent login - code step
    'auth.parent.code.sentTo': 'Code sent to',
    'auth.parent.code.validity': '. Valid for 15 minutes.',
    'auth.parent.code.devHeader': 'Dev mode:',
    'auth.parent.code.devLabel': 'code',
    'auth.parent.code.label': '6-digit code',
    'auth.parent.code.placeholder': '000000',
    'auth.parent.code.verifyAndLogin': 'Verify & log in',

    // Parent register
    'auth.parent.register.intro': 'Register with email and password, then open the activation link in your email. After that you can add kid accounts.',
    'auth.parent.register.email.label': 'Parent email',
    'auth.parent.register.password.label': 'Set a password (at least 6 chars)',
    'auth.parent.register.invite.label': 'Invite code (optional)',
    'auth.parent.register.invite.placeholder': 'e.g. abc123',
    'auth.parent.register.invite.hint': "✨ A friend's invite code — you get +1000 welcome coins, and the inviter earns after your family starts",
    'auth.parent.register.sendCode': 'Send activation email →',
    'auth.parent.register.codeSentTo': 'Code sent to',
    'auth.parent.register.codeTail': '. You can also open the activation link in the email.',
    'auth.parent.register.activate': 'Activate & enter 🎉',

    'auth.parent.reset.intro': "Enter the parent email and we'll send a password reset link.",
    'auth.parent.reset.send': 'Send reset link',
    'auth.parent.reset.sentTo': 'Reset link and code sent to',
    'auth.parent.reset.newPassword': 'New password (6+ chars)',
    'auth.parent.reset.submit': 'Save new password',

    // Errors
    'auth.error.childMissing': 'Please fill in your name and a password of at least 4 characters.',
    'auth.error.emailMissing': 'Please enter your email.',
    'auth.error.passwordMissing': 'Please enter your password.',
    'auth.error.codeFormat': 'Please enter the 6-digit code.',
    'auth.error.emailFormat': "That email doesn't look right.",
    'auth.error.passwordShort': 'Password needs at least 6 characters.',
    'auth.error.generic': 'Something went wrong 😢',

    // Nickname modal
    'nicknameModal.welcome': 'Hey {name}, welcome!',
    'nicknameModal.prompt.line1': 'Want to pick a little nickname?',
    'nicknameModal.prompt.line2': "It's the name your hamster will use when chatting with you 🐹",
    'nicknameModal.placeholder': 'e.g. Sunny, Mochi, Super Lightning',
    'nicknameModal.keepLoginName.title': 'Just use my login name',
    'nicknameModal.keepLoginName.button': "Just call me {name}",
    'nicknameModal.confirm': 'This one!',
    'nicknameModal.error.length': 'Nickname needs 1-20 characters.',
    'nicknameModal.error.saveFailed': "Couldn't save",

    // ─── Wizard (PR-9 redesign) ─────────────────────────────
    // Step 1 — who are you?
    'auth.wizard.step.label': 'Step {n} of {total}',
    'auth.wizard.back': '‹ Back',
    'auth.wizard.role.title': 'Who are you?',
    'auth.wizard.role.subtitle': 'Tap one of the big buttons below',
    'auth.wizard.role.child.title': "I'm a kid",
    'auth.wizard.role.child.sub': 'Play, chat, earn coins',
    'auth.wizard.role.parent.title': "I'm a parent",
    'auth.wizard.role.parent.sub': 'Tasks, allowance, learning',

    // Step 2 — have an account?
    'auth.wizard.has.title.child': 'Do you already have an account?',
    'auth.wizard.has.title.parent': 'Do you already have an account?',
    'auth.wizard.has.subtitle.child': "If not, we'll make one together ✨",
    'auth.wizard.has.subtitle.parent': "First time? Create one. Returning? Just log in.",
    'auth.wizard.has.login.title': 'I have an account',
    'auth.wizard.has.login.sub': 'Log me in',
    'auth.wizard.has.register.title': 'Create account',
    'auth.wizard.has.register.sub.child': 'Sign up and play',
    'auth.wizard.has.register.sub.parent': 'Sign up with email',

    // Step 3 — titles per role × mode
    'auth.wizard.step3.title.childLogin': 'Kid login',
    'auth.wizard.step3.title.childRegister': 'Kid sign-up',
    'auth.wizard.step3.title.parentLogin': 'Parent login',
    'auth.wizard.step3.title.parentRegister': 'Parent sign-up',
    'auth.wizard.step3.title.parentForgot': 'Reset password',
  },
};

export default auth;
